import { useState } from 'react';
import { Trigger } from '@radix-ui/react-popover';
import type { TModelSpec, TEndpointsConfig } from 'librechat-data-provider';
import { useLocalize } from '~/hooks';
import SpecIcon from './SpecIcon';
import { cn } from '~/utils';

export default function MenuButton({
  selected,
  className = '',
  textClassName = '',
  primaryText = '',
  secondaryText = '',
  endpointsConfig,
}: {
  selected?: TModelSpec;
  className?: string;
  textClassName?: string;
  primaryText?: string;
  secondaryText?: string;
  endpointsConfig: TEndpointsConfig;
}) {
  const localize = useLocalize();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Trigger asChild>
      <button
        className={cn(
          'group flex cursor-pointer items-center gap-1 rounded-xl pl-4 pr-2 py-1.5 text-lg font-medium hover:bg-[#F2F2F2] radix-state-open:bg-[#F2F2F2] dark:hover:bg-[#1c2846] dark:radix-state-open:bg-[#1c2846]',
          className,
        )}
        type="button"
        aria-label={localize('com_ui_llm_menu')}
        role="combobox"
        aria-haspopup="listbox"
        aria-expanded={isExpanded}
        aria-controls="llm-menu"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {/* {selected && selected.showIconInHeader === true && (
          <SpecIcon currentSpec={selected} endpointsConfig={endpointsConfig} />
        )} */}
        <div className={textClassName}>
          {!selected ? localize('com_ui_none_selected') : primaryText}{' '}
          {!!secondaryText && <span className="text-token-text-secondary">{secondaryText}</span>}
        </div>
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          className="text-[#0F172A] dark:text-white"
        >
          <path
            d="M11.3346 7.83203L8.00131 11.1654L4.66797 7.83203"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </Trigger>
  );
}
